import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DriftIcons, IconButton } from 'drift-ui';
import cx from 'classnames';
import { RootState } from 'app/configureStore';
import RTSPro from '../assets/images/RTSPro.svg';
import RTSLogo from '../assets/images/RTS_white.svg';

import style from './Navigation.scss';
const { KeyboardArrowLeft } = DriftIcons;

export const HeaderNavigation: FC<{ title?: string; hideBackButton?: boolean }> = ({
  title,
  hideBackButton = false,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const features = useSelector((state: RootState) => state?.persistedReducer?.activeFeatures || []);
  const isNewLogoEnabled = features.includes('7b6b33f6d1ca0f1d7416a24414c3cfc53f73957fbb3bf8a7ec62ea33c1b540d2');

  const navigatePreviousSection = () => {
    dispatch({ type: 'SET_FACTORING_SECTION', factoringSection: 5 });
    navigate(-1);
  };

  return (
    <nav>
      <div className={cx(style.bannerContainer, isNewLogoEnabled && style.newBannerPadding)}>
        <div className={style.backAndLogo}>
          <IconButton
            color="inherit"
            onClick={navigatePreviousSection}
            style={{ visibility: hideBackButton ? 'hidden' : 'visible' }}
          >
            <KeyboardArrowLeft fontSize="large" color="inherit" />
          </IconButton>
          <img
            className={cx(style.logo, isNewLogoEnabled && style.newLogoHeight)}
            src={isNewLogoEnabled ? RTSLogo : RTSPro}
            alt={isNewLogoEnabled ? 'RTS Logo' : 'RTSPro Logo'}
          />
        </div>
        {title && <div className={style.bannerTitle}>{title}</div>}

        <div className={style.lastColumn} />
      </div>
    </nav>
  );
};

export default HeaderNavigation;
